import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { CButton, CForm, CModal, CModalBody } from '@coreui/react-pro';

import { Formik } from 'formik';

import { SelectSearchField, SimpleInputGroup, SimpleSelectGroup } from '../../../General/Forms';
import { Waiting } from '../../../General/Loadings';
import { getCountryValueByCountry, getListOptionsCountryByCountry, getListTimeZonesMoment } from '../../../../utils';

import { addSubscriberOrganization } from './actions';
import { LOCAL_TIME_ZONE, STATUS } from '../../../../constants';
import { fetchSubscriberLicenseesRequest } from '../Licensees/actions';

const CreateOrganization = ({ setShowPopup }) => {
     const dispatch = useDispatch();
     const navigate = useNavigate();

     const user = useSelector((state) => state.subscriber.user);
     const licensees = useSelector((state) => state.subscriber.licensees);
     const timezoneUser = localStorage.getItem(LOCAL_TIME_ZONE);
     const currentLicensee = user?.country && licensees?.length > 0 ? licensees.find((item) => item.country.includes(user.country)) : null;
     const userCountry = getCountryValueByCountry(user?.country);
     const countryOptions = getListOptionsCountryByCountry(userCountry, licensees);

     const initialValues = {
          name: '',
          timezone: timezoneUser || user?.timezone,
          country: userCountry,
     };

     const [listTimezones, setListTimezones] = useState(getListTimeZonesMoment(user?.country));

     const timezoneValue = listTimezones.find((tz) => tz.value === initialValues.timezone);
     if (!timezoneValue) {
          initialValues.timezone = null;
     }

     const fetchLicensees = () => {
          if (!licensees) {
               dispatch(fetchSubscriberLicenseesRequest());
          }
     };

     useEffect(() => {
          fetchLicensees();
     }, []); // eslint-disable-line react-hooks/exhaustive-deps

     const handleClosePopupClick = () => {
          setShowPopup(false);
     };

     const handleSubmitForm = (values, { setSubmitting }) => {
          const newValues = {
               ...values,
               name: values.name.trim(),
               licenseeId: currentLicensee?.id,
               status: STATUS.ENABLE,
          };
          dispatch(addSubscriberOrganization(newValues, setSubmitting, setShowPopup, navigate));
     };

     const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

     const validationSchema = (values) => {
          return sleep(100).then(() => {
               const errors = {};

               if (!values.name) {
                    errors.name = 'Required.';
               }

               if (!values.country) {
                    errors.country = 'Required.';
               }

               if (!values.timezone) {
                    errors.timezone = 'Required.';
               }
               return errors;
          });
     };

     return (
          <>
               <CModal alignment="center" visible={true} className="popup-custom create-org-popup">
                    <CButton className="close-modal-button" onClick={handleClosePopupClick}></CButton>
                    <CModalBody>
                         <h2 className="text-center popup-title">Create Your Organization</h2>
                         <Formik
                              initialValues={initialValues}
                              validate={validationSchema}
                              onSubmit={handleSubmitForm}
                              validateOnChange={false}
                              validateOnBlur={false}
                              enableReinitialize
                         >
                              {({ values, errors, handleChange, setFieldValue, setErrors, handleSubmit, isSubmitting }) => {
                                   if (values.country !== '') {
                                        delete errors.country;
                                   }

                                   const timezoneValue = listTimezones.find((tz) => tz.value === values.timezone);

                                   const customHandleChangeOrgName = (e) => {
                                        const name = e.target.value.trim();

                                        if (name) {
                                             delete errors.name;
                                        } else {
                                             errors.name = 'Required.';
                                             setErrors({ ...errors, name: 'Required.' });
                                        }

                                        if (name.length > 0) {
                                             const value = e.target.value;
                                             setFieldValue('name', value);
                                        } else {
                                             setFieldValue('name', name);
                                        }
                                   };

                                   const handleChangeCountry = (e) => {
                                        const country = e.target.value;
                                        setFieldValue('country', country);
                                        setFieldValue('timezone', null);

                                        if (errors.country && country) {
                                             delete errors.country;
                                        } else if (!country) {
                                             errors.country = 'Required.';
                                             setErrors({ ...errors, country: 'Required.' });
                                        }

                                        if (country) {
                                             setListTimezones(getListTimeZonesMoment(country));
                                        } else {
                                             setListTimezones([]);
                                        }
                                   };

                                   const customHandleChangeOrgTimeZone = (e, setFieldValue) => {
                                        if (e.value) {
                                             delete errors.timezone;
                                        }
                                        setFieldValue('timezone', e.value);
                                   };

                                   return (
                                        <CForm onSubmit={handleSubmit} noValidate>
                                             <SimpleInputGroup
                                                  id="name"
                                                  label="Organization Name"
                                                  className="input-custom-wrap"
                                                  classNameInput="input-custom"
                                                  isRequired
                                                  value={values.name}
                                                  error={errors.name}
                                                  disabled={isSubmitting}
                                                  handleChange={customHandleChangeOrgName}
                                             />
                                             <SimpleSelectGroup
                                                  id="country"
                                                  name="country"
                                                  label="Organization Country "
                                                  className="input-custom-wrap"
                                                  classNameInput="input-custom dropdown-custom"
                                                  isRequired
                                                  optionNameDefault="Select Country..."
                                                  value={values.country}
                                                  error={errors.country}
                                                  disabled={isSubmitting}
                                                  data={countryOptions}
                                                  handleChange={handleChangeCountry}
                                             />
                                             <SelectSearchField
                                                  id="timezone"
                                                  label="Organization Time Zone "
                                                  classNameWrap="input-custom-wrap"
                                                  classNameInput="input-custom select-search-custom"
                                                  placeholder="Select Time Zone..."
                                                  options={listTimezones}
                                                  selectInputType={false}
                                                  value={timezoneValue}
                                                  error={errors.timezone}
                                                  disabled={!values.country || isSubmitting}
                                                  isRequired
                                                  onChange={(e) => customHandleChangeOrgTimeZone(e, setFieldValue)}
                                             />
                                             <div className="login-section-card-button mt-3">
                                                  <CButton className="btn-blue-highlight btn-h-50 btn-border" type="submit" disabled={isSubmitting}>
                                                       <Waiting isLoading={isSubmitting}>Create new Organization</Waiting>
                                                  </CButton>
                                             </div>
                                        </CForm>
                                   );
                              }}
                         </Formik>
                    </CModalBody>
               </CModal>
          </>
     );
};

export default CreateOrganization;
